'use client';

import { useState } from 'react';

import { Modal } from '@/components/Modal';
import { Button } from '@/components/ui/button';
import { BlogSpot } from '@/payload-types';
import { cn } from '@/utils/cn';

import styles from './BlogSpot.module.scss';

type Props = {
  className?: string;
  blogSpot: BlogSpot;
};

export const BlogSpotClient: React.FC<Props> = (props) => {
  const { blogSpot, className } = props;
  const [modalOpen, setModalOpen] = useState(false);
  if (!blogSpot) return;

  const { buttonLabel, description, modalContent, modalTitle, title } =
    blogSpot;

  const handleModalOpen = () => {
    setModalOpen(true);

    // Lock body scroll
    document.body.style.overflow = 'hidden';
  };

  const handleModalClose = () => {
    setModalOpen(false);

    // Unlock body scroll
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <div className={cn(styles.spot, className)}>
        {title && <div className={styles.title}>{title}</div>}
        {description && <div className={styles.description}>{description}</div>}
        {buttonLabel && (
          <Button
            className='button button--level-1 button--medium'
            onClick={handleModalOpen}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
      <Modal
        clickHandler={handleModalClose}
        content={modalContent || {}}
        modalOpen={modalOpen}
        title={modalTitle}
      />
    </>
  );
};
